module.exports = {
      id: "arrow-grey-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite-b16b2d73f82c96a320ba0490c6416430.svg#arrow-grey",
      toString: function () {
        return this.url;
      }
    }